<mat-card mat-card class="cur-card">
  <mat-card-content>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <div fxFlex="80" fxFlex.lt-md="100">
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>売上年月</mat-label>
            <input matInput id="claimCalcYmt" value="{{urikakekinInfo.cdtmnySyosaiInfDto.claimCalcYmt ? (urikakekinInfo.cdtmnySyosaiInfDto.claimCalcYmt | slice:0:4) + '/' + 
            (urikakekinInfo.cdtmnySyosaiInfDto.claimCalcYmt | slice:4:6) : ''}}"
              class="font-color-display-only" disabled />
          </mat-form-field>
          <mat-form-field appearance="fill" class="input-form" fxFlex="50" fxFlex.lt-md="100" style="visibility:hidden">
            <mat-label>計算区分</mat-label>
            <input matInput id="chargeCorrctDiv" value="{{urikakekinInfo.cdtmnySyosaiInfDto.chargeCorrctDivAname}}" class="font-color-display-only"
              disabled />
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>調定日</mat-label>
            <input matInput id="choteiDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.choteiDate ? (urikakekinInfo.cdtmnySyosaiInfDto.choteiDate | slice:0:4) + '/' + 
            (urikakekinInfo.cdtmnySyosaiInfDto.choteiDate | slice:4:6) + '/' + 
            (urikakekinInfo.cdtmnySyosaiInfDto.choteiDate | slice:6:8) 
            : ''}}" class="font-color-display-only" disabled />
          </mat-form-field>
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>貸倒償却日</mat-label>
            <input matInput id="lossRegDate" value="{{urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate ? (urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate | slice:0:4) + '/' + 
            (urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate | slice:4:6) + '/' + 
            (urikakekinInfo.cdtmnySyosaiInfDto.lossRegDate | slice:6:8) 
            : ''}}" class="font-color-display-only"
              disabled />
          </mat-form-field>
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>合計金額</mat-label>
            <input matInput id="cdtmnyAllMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.cdtmnyAllMny | number:'1.0-0'}}" class="font-color-display-only"  style="text-align: right;"
              disabled />
            <span matSuffix>円</span>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>ご使用期間</mat-label>
            <!-- 期間の～表示有無をpipeに実装 -->
            <input matInput id="calcDate" value="-" class="font-color-display-only"
              disabled />
          </mat-form-field>
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>まとめ請求</mat-label>
            <input matInput id="mtmclmAname" value="{{urikakekinInfo.cdtmnySyosaiInfDto.mtmclmDivAname}}"
              class="font-color-display-only" disabled />
          </mat-form-field>
          <mat-form-field appearance="fill" class="input-form" fxFlex="33" fxFlex.lt-md="100">
            <mat-label>内消費税（参考）</mat-label>
            <input matInput id="csptaxMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.csptaxMny | number:'1.0-0'}}" class="font-color-display-only"  style="text-align: right;"
              disabled />
            <span matSuffix>円</span>
          </mat-form-field>
        </div>
        <!-- <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="fill" class="input-form" fxFlex="1" fxFlex.lt-md="100" style="visibility:hidden">
            <mat-label>請求月度</mat-label>
            <input matInput id="clmcrgClaimKeijym" value="{{urikakekinInfo.cdtmnySyosaiInfDto.clmcrgClaimKeijym}}"
              class="font-color-display-only" disabled />
          </mat-form-field>
        </div> -->
      </div>
      <div fxFlex="5" style="margin-top: 20px"></div>
      <!-- <div fxFlex="25" fxFlex.lt-md="100">
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="fill" class="input-form" fxFlex="100" fxFlex.lt-md="100">
            <mat-label>合計金額</mat-label>
            <input matInput id="cdtmnyAllMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.cdtmnyAllMny | number:'1.0-0'}}" class="font-color-display-only"  style="text-align: right;"
              disabled />
            <span matSuffix>円</span>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center">
          <mat-form-field appearance="fill" class="input-form" fxFlex="100" fxFlex.lt-md="100">
            <mat-label>内消費税（参考）</mat-label>
            <input matInput id="csptaxMny" value="{{urikakekinInfo.cdtmnySyosaiInfDto.csptaxMny | number:'1.0-0'}}" class="font-color-display-only"  style="text-align: right;"
              disabled />
            <span matSuffix>円</span>
          </mat-form-field>
        </div>
      </div> -->
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center" style="margin-top: 20px;">
      <table mat-table id="cdtmnyDetailInfTbl" [dataSource]="urikakekinInfo.cdtmnySyosaiInfDto.cdtmnyDetailInfDto" fxFlex="60" fxFlex.lt-lg="100"
        style="width: 100%; border: solid 1px rgba(0, 0, 0, 0.12);">
        <ng-container matColumnDef="detailHyojiAname">
          <th mat-header-cell class="border-bottom-double" style="width: 20%; font-weight: bold;" *matHeaderCellDef>項目
          </th>
          <td mat-cell id="detailHyojiAname" class="border-bottom-double" style="width: 20%;  font-weight: bold;" *matCellDef="let e">
            {{e.detailHyojiAname }}</td>
        </ng-container>
        <ng-container matColumnDef="chargeCodeMny">
          <th mat-header-cell class="border-bottom-double" style="width: 20%; font-weight: bold;" *matHeaderCellDef>金額
          </th>
          <td mat-cell id="chargeCodeMny" class="border-bottom-double table-cell-type-num" style="width: 20%" *matCellDef="let e">
            <div *ngIf="prdClsfyDiv=='32'">
              {{e.chargeCodeMny | number:'1.4-4' }}円
            </div>
            <div *ngIf="prdClsfyDiv!='32'">
              {{e.chargeCodeMny | number:'1.2-2' }}円
            </div>        
          </td>
        </ng-container>

        <tr mat-header-row class="border-bottom-double" *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row class="border-bottom-double" *matRowDef="let row; columns: displayedColumns" class="mat-row">
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>